import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { errText } from '../../lib/rentalRegisterAPI';

// Dense editable key/value grid. fields: [key, label, type?('text'|'date'|'number'|'bool'|string[] options)]
export const KV = ({ fields, value, onSave, canEdit, testid }) => {
  const [f, setF] = useState(value || {});
  const [edit, setEdit] = useState(false);
  useEffect(() => { setF(value || {}); }, [value]);
  const save = async () => { try { await onSave(Object.fromEntries(fields.map(([k]) => [k, f[k] ?? null]))); setEdit(false); toast.success('Saved'); } catch (e) { toast.error(errText(e)); } };
  const show = (k, t) => (t === 'bool' ? (value?.[k] ? 'Yes' : 'No') : value?.[k] ?? '—');
  const input = (k, t) => {
    if (Array.isArray(t)) return <select className="border rounded h-8 px-1 text-sm w-full" value={f[k] || ''} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`${testid}-${k}`}><option value="">—</option>{t.map((o) => <option key={o}>{o}</option>)}</select>;
    if (t === 'bool') return <input type="checkbox" checked={!!f[k]} onChange={(e) => setF({ ...f, [k]: e.target.checked })} data-testid={`${testid}-${k}`} />;
    return <Input className="h-8 text-sm" type={t || 'text'} value={f[k] ?? ''} onChange={(e) => setF({ ...f, [k]: t === 'number' ? (e.target.value === '' ? null : Number(e.target.value)) : e.target.value })} data-testid={`${testid}-${k}`} />;
  };
  return (
    <div data-testid={testid}>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-1.5 text-sm">
        {fields.map(([k, l, t]) => <div key={k}><div className="text-[11px] text-muted-foreground">{l}</div>{edit ? input(k, t) : <div className="truncate" data-testid={`${testid}-val-${k}`}>{String(show(k, t))}</div>}</div>)}
      </div>
      {canEdit && <div className="mt-2 flex gap-2">{edit ? <><Button size="sm" onClick={save} data-testid={`${testid}-save`}>Save</Button><Button size="sm" variant="ghost" onClick={() => setEdit(false)}>Cancel</Button></>
        : <Button size="sm" variant="outline" onClick={() => setEdit(true)} data-testid={`${testid}-edit`}>Edit</Button>}</div>}
    </div>
  );
};

// List of multi-records (loans / managers) with add + edit using KV.
export const RecordList = ({ rows, fields, onAdd, onEdit, canEdit, testid, title }) => {
  const [adding, setAdding] = useState(false);
  return (
    <div className="space-y-2" data-testid={testid}>
      {rows.length === 0 && <p className="text-sm text-muted-foreground">No {title} recorded.</p>}
      {rows.map((r) => <div key={r.id} className="rounded border p-2"><KV fields={fields} value={r} canEdit={canEdit} onSave={(v) => onEdit(r.id, v)} testid={`${testid}-${r.id.slice(0, 6)}`} /></div>)}
      {canEdit && (adding ? <div className="rounded border p-2 border-dashed"><KV fields={fields} value={{}} canEdit onSave={async (v) => { await onAdd(v); setAdding(false); }} testid={`${testid}-new`} /></div>
        : <Button size="sm" variant="outline" onClick={() => setAdding(true)} data-testid={`${testid}-add`}>Add {title.replace(/s$/, '')}</Button>)}
    </div>
  );
};
